
import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { AlertRuleService } from "src/app/shared/services/alert-rule.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { constants } from "src/app/shared/common/contants";
import { CreateMeetingPopUpComponent } from "./create-meeting-pop-up/create-meeting-pop-up.component";
import { GenericBadgeRendererComponent } from "src/app/shared/common/generic-badge-renderer.component";
import { AgGridActionbutton } from "src/app/shared/common/AgGridActionbutton";
import { ParticipantsDialogComponent } from "./participants-dialog/participants-dialog.component";

@Component({
    selector: "app-meetings",
    templateUrl: "./meetings.component.html",
    styleUrls: ["./meetings.component.scss"],
    standalone: false
})
export class MeetingsComponent implements OnInit {
  meetingsData: any;
  defaultColDef: any;
  columnDefs: any;
  gridOptions: any;
  rowClassRules: any;
  getRowStyle: any;
  components: any;
  backgroundColorButton: string;

  gridApi: any;
  clickTimeout: any;
  activeFilter: string | null = null;
  overdueCount: number;
  todayCount: number;
  upcomingCount: number;
  totalCount: number;
createdByMeCount: any;
thisWeekCount: any;
showLatestOnly: boolean = true;
allMeetings: any[] = [];
filteredMeetings: any[] = [];

  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private alertRuleService: AlertRuleService,
    private constants: constants,
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
      buttonRenderer: AgGridActionbutton
    };
  }

  ngOnInit(): void {
    this.intializeGrid();
    this.loadMeetings();
  }


  intializeGrid() {
    // Set theme colors
    this.backgroundColorButton =
      this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [
     {
    headerName: "Meeting Subject",
    field: "meetingSubject",
    width: 250,
    ...this.jsignalsService.autoTooltip("Meeting Subject"),
  },

  {
    headerName: "Meeting Link",
    field: "meetingLink",
    width: 250,
          cellRenderer: (params: any) => {
       return `<span class="participant-link">${params.value}</span>`;
      },
      onCellClicked: (params: any) => {
                    if (params.data.status === "No") {
                  this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
                  return;
                }
        const url = params.value;
        if (url) {
          window.open(url, "_blank");
        }
  },
    ...this.jsignalsService.autoTooltip("Meeting Link"),
  },
    {
    headerName: "Agenda",
    field: "agenda",
    width: 300,
    ...this.jsignalsService.autoTooltip("Agenda"),
  },

    {
    headerName: "Meeting Start date",
    field: "meetingStartDate",
    width: 250,
    ...this.jsignalsService.autoTooltip("Meeting Start date"),
  },

  {
    headerName: "Meeting Start  Time",
    field: "meetingStartTime",
    width: 200,
    ...this.jsignalsService.autoTooltip("Meeting Start Time"),
  },

    {
    headerName: "Meeting End  Time",
    field: "meetingEndTime",
    width: 200,
    ...this.jsignalsService.autoTooltip("Meeting End Time"),
  },

{
  headerName: "Participants",
  field: "participantCount",
  width: 180,
  cellRenderer: (params: any) => {
    return `<span class="participant-link">${params.value}</span>`;
  },
  onCellClicked: (params: any) => {
                    if (params.data.status === "No") {
                  this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
                  return;
                }
    this.openParticipantsDialog(params.data.id);
  },
  ...this.jsignalsService.autoTooltip("Participants"),
},

  // {
  //   headerName: "Meeting Type",
  //   field: "meetingType", // ONE_TIME | RECURRING
  //   cellRenderer: (params: any) => {
  //     const isRecurring = params.value === "RECURRING";
  //     const badgeClass = isRecurring
  //       ? "status-badge info"
  //       : "status-badge neutral";

  //     return `
  //       <span class="${badgeClass}">
  //         <span class="dot"></span>${params.value}
  //       </span>`;
  //   },
  //   ...this.jsignalsService.autoTooltip("Meeting Type"),
  // },

  {
        headerName: "Status",
         width:120,
        field: "status", // "Yes" | "No"
        cellRenderer: GenericBadgeRendererComponent,
        cellRendererParams: { type: 'YES_NO' },
        ...this.jsignalsService.autoTooltip("Status"),
      },
      {
    headerName: "Meeting Type",
    field: "isRecurring",
    valueFormatter: (params: any) => (params.value ? "Recurring" : "One Time"),
     ...this.jsignalsService.autoTooltip("Meeting Type"),
    tooltipValueGetter: (params: any) => 'Meeting Type : ' + (params.value ? "Recurring" : "One Time"),
    width: 200,
  },

  {
    headerName: "Created By",
    field: "createdBy",
    ...this.jsignalsService.autoTooltip("Created By"),
  },

  {
    headerName: "Created Date",
    field: "createdDate",
    ...this.jsignalsService.autoTooltip("Created Date"),
  },

  {
    headerName: "Last Modified Date",
    field: "lastModifiedDate",
    ...this.jsignalsService.autoTooltip("Last Modified Date"),
  },

  {
    headerName: "Last Modified By",
    field: "lastModifiedBy",
    ...this.jsignalsService.autoTooltip("Last Modified By"),
  },

    {
    headerName: "Is Latest",
    field: "isLatest",
    ...this.jsignalsService.autoTooltip("Is Latest"),
  },

      {
    headerName: "Meeting Id",
    field: "meetingId",
    ...this.jsignalsService.autoTooltip("Meeting Id"),
  },

      {
    headerName: "Schedule Id ",
    field: "scheduleId",
    ...this.jsignalsService.autoTooltip("Schedule Id "),
  },
    {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: false,
        width:150,
        cellRenderer: "jsignalButton",
        pinned: "right",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }),
      },
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

    // if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.getRowStyle = (params: any) => {
      console.log(params);
      console.log(params.data.status);
      if (params.data.status === "No") {
        return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
      }
      if (params.data.isLatest == false) {
        return { backgroundColor: "rgb(253, 245, 207)" }; // Inline style for older version rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
  }

  onCreate() {
  const dialogRef = this.dialog.open(CreateMeetingPopUpComponent, {
          maxWidth: '100vw',
      height: "95%",
      width: "80%",
    disableClose: true,
     autoFocus: false,
    data: { mode: 'CREATE'} 
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log('Meeting Created:', result);
      // call API / refresh grid
      this.loadMeetings();
    }
  });
}

EditIcon(params: any) {

                  if (params.rowData.status === "No") {
                  this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
                  return;
                }
             if (params.rowData.isLatest == false) {
                  this.snackBar.open("Cannot edit older version", "OK", { duration: 5000 });
                  return;
                }
  const dialogRef = this.dialog.open(CreateMeetingPopUpComponent, {
    maxWidth: '100vw',
    height: '95%',
    width: '80%',
     autoFocus: false,
    disableClose: true,
    data: {
      mode: 'EDIT',
      meetingData: params.rowData   // full row data
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log('Meeting Updated:', result);
      this.loadMeetings();
    }
  });
}


deleteIcon(params: any) {
                  if (params.rowData.status === "No") {
                  this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
                  return;
                }
              if (params.rowData.isLatest == false) {
                  this.snackBar.open("Cannot delete older version", "OK", { duration: 5000 });
                  return;
                }
  console.log('Delete clicked', params.rowData.id);
  this.spinner.start();
    this.jsignalsService
      .deleteMeeting(params.rowData.id)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.loadMeetings();
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.loadMeetings();
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
         this.loadMeetings();
          this.spinner.stop();
        },
      });  
}




  onRefresh() {
    this.loadMeetings();
  }

  onDownload() {
    console.log("Download clicked");
    // export logic (CSV / Excel)

    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "Meetings.csv",
      });

      this.spinner.stop();
    }, 500);
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
        // Apply the "Latest Only" filter if default is true
    if (this.showLatestOnly) {
      this.onToggleLatestOnly(true);
    }
  }

  loadMeetings() {
     this.spinner.start();
    this.jsignalsService
      .getAllMeetings()
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.meetingsData = [];
            this.spinner.stop();
            return;
          }
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
          this.meetingsData = res  || [];

          //for calculation of stats 
        
          // this.filteredMeetings = res;
          this.reApplyCurrentFilter();

          this.calculateCounts();

          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.meetingsData = [];
          this.spinner.stop();
        },
      });  
  }

  /** Handle click vs double-click */
  onCardClick(status: string) {
    debugger;
    if (this.clickTimeout) {
      // Double-click detected → clear filter
      clearTimeout(this.clickTimeout);
      this.clickTimeout = null;
      this.clearFilter();
      return;
    }

    // Single-click detected (wait to confirm it's not a double)
    this.clickTimeout = setTimeout(() => {
      this.clickTimeout = null;
      this.applyFilter(status);
    }, 250); // 250ms threshold for double-click
  }

  //   clearFilter() {
  //   if (!this.gridApi) return;

  //   this.activeFilter = null;
  //   this.gridApi.setFilterModel(null);
  //   this.gridApi.onFilterChanged();
  //   this.gridApi.setGridOption('rowData', this.meetingsData);
  //   // this.updateStats(this.rowData);
  // }


  applyFilter(type: string): void {
  this.activeFilter = type;

  let filtered = this.meetingsData;

  if (type !== 'all') {
    filtered = this.meetingsData.filter(t =>
      type === 'overdue' || type === 'today' || type === 'upcoming'
        ? t.dueStatus === type
        : t.taskType === type
    );
  }

  this.gridApi?.setGridOption('rowData', filtered);
  // this.updateStats(filtered);
}

updateStats(data: any[]): void {
  this.overdueCount = data.filter(t => t.dueStatus === 'overdue').length;
  this.todayCount = data.filter(t => t.dueStatus === 'today').length;
  this.upcomingCount = data.filter(t => t.dueStatus === 'upcoming').length;
  this.totalCount = data.length;
}

openParticipantsDialog(meetingId: number) {
  this.spinner.start();
    this.jsignalsService
      .getMeetingParticipants(meetingId)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            
            this.spinner.stop();
            return;
          }
          // this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.dialog.open(ParticipantsDialogComponent, {
              width: '400px',
              data: res
            });
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
         
          this.spinner.stop();
        },
      });  
}

  onToggleLatestOnly(checked: boolean) {
    if (!this.gridApi) {
      console.warn("Grid API not ready");
      return;
    }
    if (checked) {
      // filter to show only latest meetings
      this.filterMeetings('latest');
    } else {
      // clear filters
      this.filterMeetings('all');
    }

    
  }

 calculateCounts() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayStr = today.toISOString().split('T')[0];

  // Calculate end of week (next 7 days from today)
  const endOfWeek = new Date(today);
  endOfWeek.setDate(today.getDate() + 7);
  const endOfWeekStr = endOfWeek.toISOString().split('T')[0];

  // Calculate start of week for counting (if you want past 7 days)
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - 7);
  const startOfWeekStr = startOfWeek.toISOString().split('T')[0];

  this.todayCount = 0;
  this.thisWeekCount = 0;
  this.upcomingCount = 0;

  const latestMeetings = this.meetingsData.filter(m => m.isLatest === true && m.status === "Yes");

  latestMeetings.forEach(meeting => {
    if (meeting.meetingStartDate === todayStr) {
      this.todayCount++;
    } 
    else if (meeting.meetingStartDate > todayStr && meeting.meetingStartDate <= endOfWeekStr) {
      this.thisWeekCount++; // Future meetings in next 7 days
    } 
    else if (meeting.meetingStartDate > endOfWeekStr) {
      this.upcomingCount++;
    }
    // Past meetings (before today) are NOT counted in any category
  });

  this.totalCount = this.meetingsData.length;
}
filterMeetings(type: string) {
  this.activeFilter = type; // highlight control

  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];

  const endOfWeek = new Date();
  endOfWeek.setDate(today.getDate() + (7 - today.getDay()));

  const latestMeetings = this.meetingsData.filter(m => m.isLatest === true &&  m.status === "Yes");

  if (type === 'today') {
    this.filteredMeetings = latestMeetings.filter(m =>
      m.meetingStartDate === todayStr
    );
  }

  else if (type === 'week') {
    this.filteredMeetings = latestMeetings.filter(m => {
      const startDate = new Date(m.meetingStartDate);
      return startDate > new Date(todayStr) && startDate <= endOfWeek;
    });
  }

  else if (type === 'upcoming') {
    this.filteredMeetings = latestMeetings.filter(m => {
      const startDate = new Date(m.meetingStartDate);
      return startDate > endOfWeek;
    });
  }

  else if (type === 'latest') {
    this.filteredMeetings = latestMeetings;
  }

  else {
    this.filteredMeetings =  this.meetingsData;
  }
}

clearFilter() {
  this.activeFilter = ''; // remove highlight
  if(this.showLatestOnly){
    const latestMeetings = this.meetingsData.filter(m => m.isLatest === true && m.status === "Yes");
    this.filteredMeetings = latestMeetings;
     return;
  }
  this.filteredMeetings = this.meetingsData; // reset grid
}

handleClick(type: string) {
  clearTimeout(this.clickTimeout);

  this.clickTimeout = setTimeout(() => {
    this.filterMeetings(type); // single click
  }, 250);
}

handleDoubleClick() {
  clearTimeout(this.clickTimeout);
  this.clearFilter(); // double click
}

// New method to re-apply current filter
reApplyCurrentFilter() {
  // If toggle is checked, apply latest filter
  if (this.showLatestOnly) {
    this.filterMeetings('latest');
  } 
  // Otherwise, apply the active card filter if any
  else if (this.activeFilter && this.activeFilter !== '') {
    this.filterMeetings(this.activeFilter);
  } 
  // Otherwise show all meetings
  else {
    this.filteredMeetings = this.meetingsData;
  }
}

}